import { proxy } from 'valtio';

export const defaultConfigurableSectionState = false;

/**
 * Whether or not the current selected state of sections is configurable to
 * a smart section
 *
 * ie, if a user has selected a locked section, multiple sections, or no
 * sections, this would be false
 * otherwise if the user has selected one, non-locked section, this would be true
 * see {@link file://./../../renderer/src/world/systems/capability/display-element-toolbar-system.ts}
 */
export const currentConfigurableSectionState = proxy({
  isSectionConfigurable: defaultConfigurableSectionState,
});
